import React from "react";
import { Text, Box, VStack, HStack, Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface EvidenceCard {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  matchPercentage: number;
}

const AccidentTab: React.FC = () => {
  const { t } = useTranslation("common");

  // Static data - will be replaced with API data later
  const accidentCards: EvidenceCard[] = [
    {
      id: "1",
      title: "ACC-2023-001",
      subtitle: "Industrial Accident Report",
      description:
        "Detailed report of workplace accident involving machinery operation, including root cause analysis and preventive measures implemented.",
      matchPercentage: 78,
    },
    {
      id: "2",
      title: "ACC-2023-002",
      subtitle: "Safety Incident Analysis",
      description:
        "Comprehensive analysis of safety incident with recommendations for improved safety protocols and equipment modifications.",
      matchPercentage: 85,
    },
  ];

  return (
    <VStack spacing={4} align="stretch">
      {accidentCards?.map((card) => (
        <Box
          key={card.id}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="8px"
          p={4}
          position="relative"
        >
          <HStack justify="space-between" align="start" mb={2}>
            <VStack align="start" spacing={1}>
              <Text fontSize="16px" fontWeight="700" color="#1A202C">
                {card?.title}
              </Text>
              <Text fontSize="14px" color="#6B7280">
                {card?.subtitle}
              </Text>
            </VStack>
            <Badge
              bg="transparent"
              color="#005EB8"
              border="1px solid #005EB8"
              borderRadius="4px"
              px={2}
              py={1}
              fontSize="12px"
              fontWeight="500"
            >
              {t("evidenceReview.matchPercentage", {
                percentage: card?.matchPercentage,
              })}
            </Badge>
          </HStack>
          <Text fontSize="14px" color="#374151" lineHeight="1.5">
            {card?.description}
          </Text>
        </Box>
      ))}
    </VStack>
  );
};

export default AccidentTab;
